<template>
  <div style="min-height: 350px">
    <!-- <div class="d-flex justify-content-between mb-3">
      <div class="">
        <h5 class="text-primary"><strong>{{ chartSeries[chartIdx].title }}</strong></h5>
      </div>
      <div class="d-flex btn-group">
        <b-button :variant="chartIdx == 0 ? 'outline-primary' : 'primary'" size="sm" class="mr-2"
          :disabled="chartIdx == 0" @click="prev()">
          <i class="fas fa-chevron-left"></i>
        </b-button>
        <b-button :variant="chartIdx + 1 == chartSeries.length
          ? 'outline-primary'
          : 'primary'
          " size="sm" :disabled="chartIdx + 1 == chartSeries.length" @click="next()">
          <i class="fas fa-chevron-right"></i>
        </b-button>
      </div>
    </div>
    <div v-for="(chart, index) in chartSeries" :key="index">
      <template v-if="index == chartIdx">
      </template>
</div> -->
    <div class="my-3">
      <h5 class="text-primary"><strong>MAINTENANCE BREAKDOWN</strong></h5>
    </div>
    <!-- <date-picker class="mb-2" style="width: 220px" v-model="year" type="year" @input="fetchFleetReports"></date-picker> -->
    <template v-if="!loading">
      <BreakdownChart :series="series" :element="`chart-breakdown-plan-emergency`" />
    </template>
    <div class="d-flex w-100 justify-content-center my-5" v-else>
      <b-spinner style="height: 74px; width: 74px;"></b-spinner>
    </div>
  </div>
</template>
<script>
import { srActions } from '@/src/Utils/helper'
import BreakdownChart from './Chart/BreakdownChart.vue'
import moment from '@/node_modules/moment/moment'

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    BreakdownChart,
  },
  data() {
    return {
      loading: false,
      fleetReports: [],
      chartIdx: 0,
      chartSeries: [
        {
          title: 'Tugboat & Barge',
          series: [
            {
              name: 'Plan Breakdown',
              type: 'bar',
              data: [60, 80, 41, 80, 60, 70, 65, 85, 90, 60, 80, 74],
            },
            {
              name: 'Emergency Breakdown',
              type: 'bar',
              data: [50, 74, 31, 40, 50, 80, 45, 70, 80, 70, 70, 86],
            },
            {
              name: 'Total Breakdown',
              type: 'line',
              data: [55, 77, 36, 60, 55, 75, 55, 77, 85, 65, 75, 76],
            },
          ],
        },
        {
          title: 'Pusher Tugboat & Pusher Barge',
          series: [
            {
              name: 'Plan Breakdown',
              type: 'bar',
              data: [60, 80, 41, 80, 60, 70, 65, 85, 90, 60, 80, 74],
            },
            {
              name: 'Emergency Breakdown',
              type: 'bar',
              data: [50, 74, 31, 40, 50, 80, 45, 70, 80, 70, 70, 86],
            },
            {
              name: 'Total Breakdown',
              type: 'line',
              data: [55, 77, 36, 60, 55, 75, 55, 77, 85, 65, 75, 76],
            },
          ],
        },
        {
          title: 'Floating Crane & Oil Barge',
          series: [
            {
              name: 'Plan Breakdown',
              type: 'bar',
              data: [60, 80, 41, 80, 60, 70, 65, 85, 90, 60, 80, 74],
            },
            {
              name: 'Emergency Breakdown',
              type: 'bar',
              data: [50, 74, 31, 40, 50, 80, 45, 70, 80, 70, 70, 86],
            },
            {
              name: 'Total Breakdown',
              type: 'line',
              data: [55, 77, 36, 60, 55, 75, 55, 77, 85, 65, 75, 76],
            },
          ],
        },
      ],
      series: [
        {
          name: 'Plan Breakdown',
          type: 'bar',
          data: [60, 80, 41, 80, 60, 70, 65, 85, 90, 60, 80, 74],
        },
        {
          name: 'Emergency Breakdown',
          type: 'bar',
          data: [50, 74, 31, 40, 50, 80, 45, 70, 80, 70, 70, 86],
        },
        {
          name: 'Total Breakdown',
          type: 'line',
          data: [55, 77, 36, 60, 55, 75, 55, 77, 85, 65, 75, 76],
        },
      ],
      user_id: JSON.parse(localStorage.getItem('profile')).id,
      year: moment().toDate(),
    }
  },
  methods: {
    ...srActions,
    async fetchFleetReports() {
      try {
        this.loading = true
        const body = {
          vehicle_type_ids: this.params?.vehicle_type_ids?.map((item) => item?.id),
          year: moment(this.params?.year).format('YYYY'),
        }
        const params = {
          user_id: this.user_id,
        }
        const res = await this.fetchReportPlanEmergencyDashboard({
          params,
          body,
        })
        this.fleetReports = res.data
        this.series[0].data = res.data.plan.map((item) => item.total)
        this.series[1].data = res.data.emergency.map((item) => item.total)
        this.series[2].data = res.data.total.map((item) => item.total)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }

    },
    next() {
      this.chartIdx = this.chartIdx + 1
    },
    prev() {
      this.chartIdx = this.chartIdx - 1
    },
  },
  watch: {
    params: {
      handler() {
        this.fetchFleetReports()
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchFleetReports()
  },
}
</script>
<style>
.bg-head-breakdown {
  background: #ff0000;
}
</style>
